import { createSlice } from "@reduxjs/toolkit"

interface OpportunityState {
  opportunityAdvisors: any
  opportunityGroups: any
  opportunityRegions: any
  opportunityPractices: any
  opportunityStatuses: any
  opportunitySelectedAdvisors: any
  opportunitySelectedGroups: any
  opportunitySelectedRegions: any
  opportunitySelectedPractices: any
  opportunitySelectedStatuses: any
  opportunityTableData: Array<any>
  opportunityPagination: {
    page: number
    limit: number
    total: number
    totalPages: number
  }
}

const initialState: OpportunityState = {
  opportunityAdvisors: [],
  opportunityGroups: [],
  opportunityRegions: [{ label: "All", region: "all", name: "all" }],
  opportunityPractices: [{ label: "All", practice_sk: "all", name: "all" }],
  opportunityStatuses: [],
  opportunitySelectedAdvisors: [{ label: "All", name: "all" }],
  opportunitySelectedGroups: [{ label: "All", name: "all" }],
  opportunitySelectedRegions: [{ label: "All", name: "all" }],
  opportunitySelectedPractices: [{ label: "All", name: "all" }],
  opportunitySelectedStatuses: [{ label: "All", name: "all" }],
  opportunityTableData: [],
  opportunityPagination: {
    page: 1,
    limit: 20, // Testing limit
    total: 0,
    totalPages: 0,
  },
}

const opportunitySlice: any = createSlice({
  name: "opportunity",
  initialState,
  reducers: {
    setOpportunityAdvisors: (state, action) => {
      state.opportunityAdvisors = action.payload
    },
    setOpportunityGroups: (state, action) => {
      state.opportunityGroups = action.payload
    },
    setOpportunityRegions: (state, action) => {
      state.opportunityRegions = action.payload
    },
    setOpportunityPractices: (state, action) => {
      state.opportunityPractices = action.payload
    },
    setOpportunityStatuses: (state, action) => {
      state.opportunityStatuses = action.payload
    },
    setOpportunitySelectedAdvisors: (state, action) => {
      state.opportunitySelectedAdvisors = action.payload
    },
    setOpportunitySelectedGroups: (state, action) => {
      state.opportunitySelectedGroups = action.payload
    },
    setOpportunitySelectedRegions: (state, action) => {
      state.opportunitySelectedRegions = action.payload
    },
    setOpportunitySelectedPractices: (state, action) => {
      state.opportunitySelectedPractices = action.payload
    },
    setOpportunitySelectedStatuses: (state, action) => {
      state.opportunitySelectedStatuses = action.payload
    },
    setOpportunityTableData: (state, action) => {
      state.opportunityTableData = action.payload
    },
    appendOpportunityTableData: (state, action) => {
      state.opportunityTableData = [
        ...state.opportunityTableData,
        ...action.payload,
      ]
    },
    setOpportunityPagination: (state, action) => {
      state.opportunityPagination = action.payload
    },
    resetOpportunityTableData: (state) => {
      state.opportunityTableData = []
      state.opportunityPagination = {
        page: 1,
        limit: 25,
        total: 0,
        totalPages: 0,
      }
    },
    updateStatusState: (state, action) => {
      const { id, status } = action.payload
      const index = state.opportunityTableData.findIndex(
        (item) => item.id === id,
      )
      if (index !== -1) {
        state.opportunityTableData[index].status = status
      }
    },
  },
})

export default opportunitySlice.reducer
export const {
  setOpportunityAdvisors,
  setOpportunityGroups,
  setOpportunityRegions,
  setOpportunityPractices,
  setOpportunityStatuses,
  setOpportunitySelectedAdvisors,
  setOpportunitySelectedGroups,
  setOpportunitySelectedRegions,
  setOpportunitySelectedPractices,
  setOpportunitySelectedStatuses,
  setOpportunityTableData,
  appendOpportunityTableData,
  setOpportunityPagination,
  resetOpportunityTableData,
  updateStatusState,
} = opportunitySlice.actions
